var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4 22.7334V24.7334L25.118 24.7334V22.7334L41.4 22.7334ZM20.1385 24.0026L26.2282 30.0667L20.1385 36.1179L18.7334 34.7128L23.4181 30.0667L18.7334 25.4077L20.1385 24.0026ZM41.4 29.0667V31.0667L29.0155 31.0667V29.0667L41.4 29.0667ZM41.4 35.4V37.4L25.118 37.4V35.4L41.4 35.4Z",
    fill: "#95A1C6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuBtn);
export default __webpack_public_path__ + "static/media/leftmenu_btn.d86203963b71fcfac534c9912c2a827e.svg";
export { ForwardRef as ReactComponent };